import { makeStyles } from "tss-react/mui-compat"

export const useListAsideStyles = makeStyles()(
  (theme) => ({
    filtersRoot: {
      width: "100%",
    },
    filtersPaperRoot: {
      width: "100%",
      padding: theme.spacing(2),
      marginRight: theme.spacing(4),
      position: "relative",
    },
    desktopFilters: {
      display: "block",
    },
    closeButton: {
      display: "block",
      bottom: 0,
      left: 0,
      width: "100%",
    },
    closeIcon: {
      display: "block",
    },
    formTitle: {
      fontFamily: "Raleway",
      fontSize: "18px",
      lineHeight: "21px",
      fontWeight: 500,
    },
  })
)
